import {
  formatPenaltyMonthLabel,
  getCurrentMonthKey,
} from "./penaltyMonthHelpers";

const HR_GRANT_SOURCES = new Set(["INVENTORY", "HR_GRANT"]);

export function isHrOvertimeGrantSource(source) {
  return HR_GRANT_SOURCES.has(source);
}

export function overtimeMonthKey(row) {
  const date = row?.startDate || row?.createdAt || "";
  const iso = String(date).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso.slice(0, 7) : null;
}

export function isApprovedOvertimeStatus(status) {
  return String(status || "").toLowerCase() === "approved";
}

export function isPendingOvertimeStatus(status) {
  const normalized = String(status || "").toLowerCase();
  return (
    normalized === "pending" ||
    normalized === "gm_pending" ||
    normalized === "in_progress"
  );
}

function sortGrantsNewestFirst(rows) {
  return [...rows].sort((a, b) => {
    const aDate = String(a?.startDate || a?.createdAt || "");
    const bDate = String(b?.startDate || b?.createdAt || "");
    return bDate.localeCompare(aDate);
  });
}

/**
 * HR overtime grants whose period falls in the current calendar month.
 * Includes approved grants and pending grants awaiting HR manager approval.
 * Employee-submitted overtime requests are excluded.
 */
export function filterMonthOvertimeGrants(
  rows = [],
  referenceDate = new Date(),
) {
  const monthKey = getCurrentMonthKey(referenceDate);
  return sortGrantsNewestFirst(
    rows.filter(
      (row) =>
        isHrOvertimeGrantSource(row?.source) &&
        (isApprovedOvertimeStatus(row?.status) ||
          isPendingOvertimeStatus(row?.status)) &&
        overtimeMonthKey(row) === monthKey,
    ),
  );
}

export function summarizeMonthOvertimeGrants(rows = []) {
  const approved = rows.filter((r) => isApprovedOvertimeStatus(r.status));
  const pending = rows.filter((r) => isPendingOvertimeStatus(r.status));
  const people = new Set(
    approved
      .map((r) => r.employeeId || r.employeeCode || r.employeeName)
      .filter(Boolean),
  );
  const approvedHours = approved.reduce((s, r) => s + Number(r.hours || 0), 0);

  return {
    approvedCount: approved.length,
    pendingCount: pending.length,
    peopleCount: people.size,
    approvedHours: Math.round(approvedHours * 100) / 100,
  };
}

export function settlementLabel(settlement) {
  if (settlement === "COMPENSATORY") return "إذن تعويضي";
  if (settlement === "PAID_OT") return "صرف مالي";
  return "صرف مالي";
}

export { formatPenaltyMonthLabel, getCurrentMonthKey };
